// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2lUSm","title":"BackImages_title__2Vlo7","images":"BackImages_images__3v9Tf"};